import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { useTranslation } from '@pascal/pascal-core';
import { limitsAndPayoutsStore } from '../../../store/limitsAndPayoutsStore';
import { WIN_COMBINATIONS, WIN_COMBINATIONS_NAMES } from '../../../enums/betTypesEnum';

const LimitAndPayouts = observer(() => {
  const { limits } = gameConfigStore;
  const { limitsPayouts } = limitsAndPayoutsStore;
  const { currencySymbolOrCode } = userInfoStore;
  const t = useTranslation();

  return (
    <div className='limit-payouts-holder'>
      <div className='tb-limit-payout-body'>
        {limitsPayouts.slice(0, 11).map(({ marketType, odd }) => (
          <div key={marketType} className='results-fairness-check-row'>
            <div className='results-fairness-check-column'>
              {marketType !== 'Box'
                ? t(WIN_COMBINATIONS_NAMES[WIN_COMBINATIONS[marketType]])
                : t('BOX')}
            </div>
            <div className='results-fairness-check-column'>
              {limits.minBet}-{limits.maxBet}
              {currencySymbolOrCode}
            </div>
            <div className='results-fairness-check-column'>x{odd}</div>
          </div>
        ))}
      </div>
    </div>
  );
});

export default LimitAndPayouts;
